module.exports = __webpack_public_path__ + "static/media/facebook-icon.2db6e2b3.svg";